/* TAVU Founders Circle — landing-page interactions.
   1) reveal-on-scroll for .fc-reveal elements
   2) sticky CTA pill: visible only AFTER the hero CTAs scroll off
   Selectors are .fc-page-scoped so this is safe to include site-wide.

   Shopify theme editor: when a merchant edits a section, Shopify re-renders
   ONLY that section's markup (Section Rendering API). A one-time observer set
   up on page load never sees those new nodes, so .fc-reveal elements stay at
   opacity:0 and the section looks blank until a full reload. We handle that:
     • In the editor (Shopify.designMode) reveal is disabled entirely —
       everything shows immediately, no animation while editing.
     • On the storefront we (re)bind observers and also re-run on
       shopify:section:load / :select so nothing is ever stuck hidden.
*/
(function () {
  'use strict';

  var inEditor = window.Shopify && window.Shopify.designMode;

  function revealAll(root) {
    (root || document).querySelectorAll('.fc-reveal').forEach(function (el) {
      el.classList.add('in');
    });
  }

  function bindReveal(root) {
    var scope = root || document;
    var els = scope.querySelectorAll('.fc-reveal:not(.in)');
    if (!els.length) return;
    if (inEditor || !('IntersectionObserver' in window)) {
      revealAll(scope);
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  function bindSticky() {
    var bar = document.getElementById('fcStickyCta');
    if (!bar) return;
    // Editor: always visible so the merchant can see + style it without
    // having to scroll inside the preview iframe.
    if (inEditor) { bar.classList.add('visible'); return; }
    // Storefront: simple scroll-position trigger. Visible once the user has
    // scrolled ~60% of the viewport — past where the hero CTA would have
    // been on first load. This avoids relying on finding/observing a
    // specific hero element, which broke when the section ordering or hero
    // markup changed.
    function update() {
      var threshold = Math.max(window.innerHeight * 0.6, 400);
      bar.classList.toggle('visible', window.scrollY > threshold);
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
  }

  function init() {
    bindReveal(document);
    bindSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: a section was (re)rendered or selected — never leave its
  // freshly injected content stuck invisible.
  document.addEventListener('shopify:section:load', function (e) {
    bindReveal(e.target);
    revealAll(e.target);
    bindSticky();
  });
  document.addEventListener('shopify:section:select', function (e) {
    revealAll(e.target);
  });
})();
